import { Icon } from "antd";

const MyIcon = Icon.createFromIconfontCN({
  scriptUrl: "//at.alicdn.com/t/font_2060357_hua19nxelpt.js" // 在 iconfont.cn 上生成
  // scriptUrl: 'font_786491_i19a3h18z7l.js', // public 目录下
});

export default MyIcon;